import { notification } from 'antd'
import { Form } from 'formsy-semantic-ui-react'
import * as R from 'ramda'
import React, { Component } from 'react'
import { Button, Confirm, Label } from 'semantic-ui-react'
import { getAddonByRace, getRaceDetailByRace } from '../../api/async/index'
import { getParticipants } from '../../api/async/participants/index'
import { getGroupByRace, patchRegisterRace } from '../../api/sync/races/index'
import { SelectAddon } from '../../components/ShirtAddon'

class EditParticipant extends Component {
  state = {
    racesDetail: [],
    confirmOpen: false,
    addons: [],
    selected_shirt: [],
    groups: []
  }

  componentDidMount = async () => {
    const participantData = await getParticipants({
      id: this.props.match.params.id
    })

    const raceId = participantData.data[0].race_detail.race.id
    const participant = participantData.data[0]

    this.setState({ participantId: participant.id })
    this.setState({ race_detail: participant.race_detail.id })
    this.setState({ engrave: participant.engrave })

    Object.keys(R.groupBy(R.path(['addon', 'type']), participant.addons))
      .reverse()
      .map(each => {
        const selectedAddons = participant.addons.filter(
          addon => addon.addon.type == each
        )
        this.setState({ [`numberOf${each}`]: selectedAddons.length })
        this.setState({
          [`selected_${each}`]: selectedAddons.map(each => each.addon.id)
        })
      })

    this.setState({ group: R.pathOr(null, ['group'], participant) })

    const res = await getRaceDetailByRace(raceId)
    this.setState({ racesDetail: res.data })

    const groups = await getGroupByRace(raceId)
    this.setState({ groups: groups.data })

    const addons = await getAddonByRace(raceId)
    this.setState({ addons: addons.data })
    if (participant.is_paid) {
      this.props.history.push('/')
      notification.warning({
        message: `คุณได้ชำระเงินแล้วไม่สามารถแก้ไขการสมัครได้`
      })
    }
  }

  handleSubmit = () => {
    this.setState({ disableSubmit: true })
    patchRegisterRace(this.state, this.state.participantId).then(res => {
      if (res.status <= 201) {
        this.setState({ disableSubmit: false })
        this.props.history.push(`/participants/payment/${res.data.id}`)
      }
    })
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }

  setNumberOfAddon = (name, value) => {
    const selectedAddons = this.state[name] || []
    this.setState({ [name]: selectedAddons.splice(0, value) })
  }

  handleNumberOfAddonChange = (e, { name, value }) => {
    const addonType = name.split('numberOf')[1]
    if (addonType === '2' && value.toString().startsWith('no_')) {
      this.state.engrave = ''
    }
    if (this.state[`numberOf${addonType}`] > value) {
      this.setNumberOfAddon(`selected_${addonType}`, value)
    }

    if (this.state.addons.filter(each => each.type == addonType).length == 1) {
      this.setState({
        [`selected_${addonType}`]: Array(value).fill(
          this.state.addons.filter(each => each.type == addonType)[0].id
        )
      })
    }

    if (value.toString().startsWith('no_')) {
      this.setState({ [`numberOf${addonType}`]: 0 })
      this.setState({ [`selected_${addonType}`]: [] })
      return
    }
    this.setState({ [name]: value })
  }

  handleRadioChange = (e, type) => {
    const selected = this.state[`selected_${type}`] || []
    const addonId = e.target.value
    const selectAddonIndex = e.target.selectAddonIndex

    selected[selectAddonIndex] = addonId
    this.setState({ [e.target.name]: selected })
  }

  render() {
    const {
      racesDetail,
      race_detail,
      selected_shirt,
      addons,
      groups
    } = this.state

    const distanceOption = [...racesDetail].map((detail, _) => ({
      key: detail.id,
      text: `${detail.distance.name} - ${detail.race.title}`,
      value: detail.id
    }))

    const groupOption = [...groups].map(group => ({
      key: group.id,
      text: `${group.name} ${group.close_register ? '(เต็มแล้ว)' : ''}`,
      value: group.id,
      disabled: group.close_register
    }))

    const errorLabel = <Label color="red" pointing />

    return (
      <React.Fragment>
        <Form
          id="first-step"
          style={{ marginBottom: '10px' }}
          onValidSubmit={() => this.setState({ confirmOpen: true })}
          onValid={this.enableButton}
          onInvalid={this.disableButton}
        >
          {groups.length ? (
            <React.Fragment>
              <h3>เลือกกลุ่ม</h3>
              <Form.Group widths="equal">
                <Form.Select
                  required
                  name="group"
                  value={this.state.group}
                  options={groupOption}
                  placeholder="โปรดเลือกกลุ่ม"
                  onChange={this.handleChange}
                />
              </Form.Group>
            </React.Fragment>
          ) : null}
          <h3>เลือกระยะทางวิ่ง / เดิน</h3>
          <Form.Group widths="equal">
            <Form.Select
              required
              name="race_detail"
              value={race_detail}
              options={distanceOption}
              placeholder="โปรดเลือกระยะวิ่ง"
              onChange={this.handleChange}
            />
          </Form.Group>
          {R.pathOr(
            false,
            ['race', 'open_engrave'],
            this.state.racesDetail[0]
          ) && (
            <React.Fragment>
              <h3>สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)</h3>
              <Form.Group>
                <Form.Input
                  validations="maxLength:12"
                  name="engrave"
                  className="mb10"
                  style={{ width: '350px', marginBottom: '10px' }}
                  value={this.state.engrave}
                  validationErrors={{
                    maxLength: 'โปรดกรอกไม่เกิน 12 ตัวอักษร'
                  }}
                  placeholder="สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)"
                  onChange={this.handleChange}
                  errorLabel={errorLabel}
                />
              </Form.Group>
            </React.Fragment>
          )}

          {[
            ...Object.keys(R.groupBy(R.prop('type'), addons))
              .filter(each => parseInt(each))
              .reverse(),
            ...Object.keys(R.groupBy(R.prop('type'), addons)).filter(
              each => !parseInt(each)
            )
          ].map(each => (
            <SelectAddon
              addons={addons.filter(addon => addon.type == each)}
              selectedAddon={this.state[`selected_${each}`]}
              handleChange={this.handleNumberOfAddonChange}
              handleRadioChange={this.handleRadioChange}
              handleEngraveChange={this.handleChange}
              engrave={this.state.engrave}
              numberOf={this.state[`numberOf${each}`]}
              type={each}
              race={R.path(['race'], this.state.racesDetail[0])}
            />
          ))}
          <div>
            <Button
              color="teal"
              type="submit"
              form="first-step"
              style={{ marginTop: '10px' }}
            >
              ต่อไป
            </Button>
          </div>
        </Form>
        <Confirm
          open={this.state.confirmOpen}
          cancelButton="แก้ไข"
          confirmButton="ตกลง"
          content="คุณยืนยันที่จะเปลี่ยนแปลงการสมัครใช่หรือไม่"
          onCancel={() => this.setState({ confirmOpen: false })}
          onConfirm={this.handleSubmit}
        />
      </React.Fragment>
    )
  }
}

export default EditParticipant



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/RegisterRace/editParticipant.js